<div class="ai-insights-modal-backdrop" *ngIf="isOpen" (click)="close()">
  <div class="ai-insights-modal" (click)="$event.stopPropagation()">
    <div class="ai-insights-modal-header">
      <div class="ai-insights-modal-doc-info">
        <span class="ai-insights-modal-doc-name">{{ documentName }}</span>
      </div>
      <button type="button" class="ai-insights-modal-close" (click)="close()">&times;</button>
    </div>
    <div class="ai-insights-modal-body">
      <div *ngIf="isLoading" class="ai-insights-loading">
        <div class="ai-insights-spinner"></div>
        <span>Loading AI Insights...</span>
      </div>
      <ng-container *ngIf="!isLoading && insightsData">
        <div class="ai-insights-layout">
          <div class="ai-insights-sidebar">
            <h3 class="ai-insights-sidebar-title"><span class="ai-insights-sparkle">&#10024;</span> AI Insights</h3>
            <p class="ai-insights-sidebar-desc">AI generated insights from this document</p>
            <div class="ai-insights-categories">
              <div class="ai-insights-category"
                   *ngFor="let category of insightsData.categories"
                   [class.active]="selectedCategory?.id === category.id"
                   (click)="selectCategory(category)">
                <span class="ai-insights-category-icon" [style.color]="category.color">{{ category.icon }}</span>
                <span class="ai-insights-category-name">{{ category.name }}</span>
                <span class="ai-insights-category-count">{{ category.items.length }}</span>
              </div>
            </div>
          </div>
          <div class="ai-insights-content">
            <div class="ai-insights-content-header" *ngIf="selectedCategory">
              <span class="ai-insights-content-icon" [style.color]="selectedCategory.color">{{ selectedCategory.icon }}</span>
              <div class="ai-insights-content-title-block">
                <h4 class="ai-insights-content-title">{{ selectedCategory.name }}</h4>
                <p class="ai-insights-content-desc">{{ selectedCategory.description }}</p>
              </div>
              <button type="button" class="ai-insights-copy-all" (click)="copyAllInsights()">&#128203; Copy All</button>
            </div>
            <div class="ai-insights-items" *ngIf="selectedCategory">
              <div class="ai-insights-item" *ngFor="let item of selectedCategory.items">
                <span class="ai-insights-item-icon" [style.color]="selectedCategory.color">{{ item.icon }}</span>
                <div class="ai-insights-item-text">{{ item.text }}</div>
                <span class="ai-insights-item-page" *ngIf="item.page">p. {{ item.page }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div *ngIf="!isLoading && !insightsData" class="ai-insights-error">
        <p>Unable to load AI Insights. Please try again.</p>
      </div>
    </div>
    <div class="ai-insights-disclaimer" *ngIf="!isLoading && insightsData">
      <span>&#9432;</span> Insights are generated by AI. Please check reference materials for complete information.

    </div>
  </div>
</div>
